import { render, staticRenderFns } from "./UserTypeDisplay.vue?vue&type=template&id=28cb1dac&scoped=true&"
import script from "./UserTypeDisplay.vue?vue&type=script&lang=js&"
export * from "./UserTypeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cb1dac",
  null
  
)

export default component.exports